import { createContext, useContext } from 'react';

/**
 * Урок показан в предпросмотре конструктора, а не ученику (D39, 13.09.2026).
 *
 * ⚠️ ЗАЧЕМ. Предпросмотр рисует НАСТОЯЩИЕ блоки ученика, и отвечать в нём можно — но
 * смотрит его сотрудник под своей учёткой. Всё, что блок пишет на сервер сам, мимо
 * `onAnswer`, ушло бы от лица админа: «в словарь» из набора слов положило бы слова в
 * его словарь. Такие блоки спрашивают этот признак и в песочнице молчат.
 *
 * Запись голоса сюда НЕ смотрит: в предпросмотре её блок не рисуется вовсе, вместо
 * него стоит заглушка (`StudentPreview`). Рекордер не трогаем — у него своя полоса.
 */
export const PreviewSandboxContext = createContext(false);

export function usePreviewSandbox(): boolean {
  return useContext(PreviewSandboxContext);
}
